import { getByPersona } from "@/api/prematriculas.api"
import { getCursoActual } from "@/api/curso.api"
import i18n from '@/i18n'

const state = {

    prematricula: null,
    curso: null,
    alumnos: [],
    alumnosid: [],
    selects: [],
    locale: i18n.locale

}

const getters = {

    /**
     * Return curso
     *
     */

    getCursoActual(state) {

        return state.curso

    },

    /**
     * Return prematricula
     * 
     */

    getPrematricula(state) {

        return state.prematricula

    },

    /**
     * Return prematricula
     * 
     */

    getLocale(state) {

        return state.locale

    },

    /**
     * Return prematricula alumnos
     * 
     */

    getPrematriculaAlumnos(state) {

        return state.alumnos

    },

    /**
     * Return alumnosids
     * 
     */

    getAlumnosIds(state) {

        return state.alumnosid

    },

    /**
     * Return the name of the alumno
     * 
     */
    
    getAlumnoName: (state) => (id) => {

        let alumnoIndex = state.alumnosid.indexOf(id)

        if ( alumnoIndex != -1 ) {

            let name = state.alumnos[alumnoIndex].name

            return name

        } else {

            return ""

        }

    },

    /**
     * Return solicitante
     * 
     */

    getPrematriculaSolicitante(state) {

        return state.prematricula.persona

    },

    /**
     * Return selects
     * 
     */

    getSelectsByAlumno: (state) => (id) => {

        return state.selects.filter(function(select) {

            return select.alumno == id

        })

    },

    /**
     * Return group incremento
     * 
     */

    getGroupIncrement (state) {

        return state.curso.incremento

    }

}

const actions = {

    /**
     * Get prematricula by persona
     * 
     */

    async getPrematriculaByPersona({ dispatch, commit },{ personaId,curso,componentId }) {

        try {

            const response = await getByPersona(personaId,curso)

            // console.log(response.data)

            if(response.status == 200) {

                commit('RESET_ALUMNOS')

                commit('SET_PREMATRICULA', response.data[0])

                dispatch('Matricula/setPrematricula', response.data[0].id, { root: true })

                dispatch('groupAlumnos')

                return true

            } else {

                dispatch('Errors/setError', { error:'CODE02', componentId: componentId }, { root: true })

            }

        } catch (error) {

            // console.log(error.response.data.code)
            // console.log('handle errors')

            dispatch('Errors/setError', { error:'CODE01', componentId: componentId }, { root: true })

        }    

    },

    async groupAlumnos({dispatch,commit,state}) {

        state.prematricula.alumnos.forEach(a => {

            let exists = state.alumnosid.indexOf( a.alumno.id )

            if(exists == -1) {

                commit('SET_ALUMNOID', a.alumno.id)
                commit('SET_ALUMNO', a)

            } else {

                commit('UPDATE_ALUMNO', a)

            }

        })

    },

    /**
     * Generate data for selects
     * 
     */

    async generateSelectData({state,commit,rootGetters,rootState}) {

        try {

            state.alumnos.forEach(alumno => {
                
                alumno.prematriculas.forEach(prematricula => {
                    let groups = []
                    let select = {
                        id: `${alumno.id}`,
                        error: false,
                        alumno: alumno.id,
                        nivel: false,
                        nivelLabel: false,
                        nivelNombre: prematricula.idioma.nombre,
                        tCode: prematricula.idioma.codigoTraduccion,
                        options: options,
                        groupsIds: groupsIds
                    }
                    let options = [{value: null, text: i18n.t('resume.groupini'), selected: true }]
                    let groupsIds = []
                    let nivelExists = false
                    
                    if(prematricula.nivel != null) {
                        rootState.Localizaciones.localizacion[0].niveles.filter(function(nivel) {
                            if(nivel.id == prematricula.nivel.id) {
                                nivelExists = true
                                return nivelExists
                            }
                        })
                        if(nivelExists) {
                            groups = rootGetters['Groups/getGroupsByNivelId'](prematricula.nivel.id)
            
                            groups.forEach(g => {
        
                                let price = g.precio
                                let full = false
                                let full_text = ''
                                let day = g.dia.descripcion
        
                                if(i18n.locale == 'eu') day = g.dia.descripcionEu
        
                                if(g.plazasDisponibles == 0 || g.plazasDisponibles == null)  {
                                    
                                    full = true
        
                                }
                                
                                if(full == true) {
                                    
                                    full_text = '('+i18n.t('forms.full')+')'
        
                                }
        
                                let option = {
                                    value: {
                                        id: prematricula.nivel.id,
                                        alumno: alumno.id,
                                        alumno_nombre: alumno.name,
                                        group_id: g.id,
                                        price: price,
                                        full: full,
                                        nivel: prematricula.nivel.descripcion,
                                        diaes: g.dia.descripcion,
                                        diaeu: g.dia.descripcionEu,
                                        horario: g.horario.descripcion,
                                        tCode: prematricula.idioma.codigoTraduccion,
                                        info: `${g.dia.descripcion} - ${g.horario.descripcion} ${full_text}`,
                                        infoeu: `${g.dia.descripcionEu} - ${g.horario.descripcion} ${full_text}`
                                    }, 
                                    text: `${day} - ${g.horario.descripcion} - ${price}€ ${full_text}`,
                                    disabled: full
                                }
                                options.push( option )
                                groupsIds.push( g.id )
        
                            })
                            
                            select = {
                                id: `${alumno.id}${prematricula.nivel.id}`,
                                error: false,
                                alumno: alumno.id,
                                nivel: prematricula.nivel.id,
                                nivelLabel: prematricula.nivel.descripcion,
                                nivelNombre: prematricula.idioma.nombre,
                                tCode: prematricula.idioma.codigoTraduccion,
                                options: options,
                                groupsIds: groupsIds
                            }
                        }
                    }

                    commit('SET_SELECT', select)

                })

            })
            
            return true

        } catch(error) {

            return error

        }

    },

    /**
     * Change the price in all the selects
     * 
     */

    changePriceInSelects({state},{paymentType,increment}) {

        let i 

        if( paymentType === 2 ) {

            i = parseInt( increment )

        } else {

            i = 0
        }

        state.selects.forEach( select => {

            select.options.forEach( (option,indexo) => {

                if( indexo != 0) {

                    let p = parseInt( option.value.price )
                    let dia = option.value.diaes
                    let full_text = ''

                    if(i18n.locale == "eu") dia = option.value.diaeu

                    if(option.value.full) full_text = '('+i18n.t('forms.full')+')'

                    option.text = `${dia} - ${option.value.horario} - ${ p + i }€ ${full_text}`

                }

            })

        })

    },

    /**
     * Change the text when the locale change in all the selects
     * 
     */

    regenerateSelectData({state},{paymentType,increment}) {

        let i 

        if( paymentType === 2 ) {

            i = parseInt( increment )

        } else {

            i = 0
        }

        state.selects.forEach( select => {

            select.options.forEach( (option,indexo) => {

                if( indexo != 0) {

                    let p = parseInt( option.value.price )
                    let dia = option.value.diaes
                    let full_text = ''

                    if(i18n.locale == "eu") dia = option.value.diaeu

                    if(option.value.full) full_text = '('+i18n.t('forms.full')+')'

                    option.text = `${dia} - ${option.value.horario} - ${ p + i }€ ${full_text}`

                } else {

                    option.text = i18n.t('resume.groupini')

                }

            })

        })

    },

    /**
     * Set errors of the select to false 
     * 
     */

    resetSelectsErrors({state,commit},{id}) {

        let select = state.selects.find( s => s.id === id )

        if( typeof select !== 'undefined' ) {

            let indexSelect = state.selects.indexOf(select)

            state.selects[indexSelect].error = false

        }

    },

    /**
     * Get the curso data from the API
     * 
     */
    async getCurso({commit, dispatch},{componentId}) {

        try {

            const response = await getCursoActual()

            if(response.status == 200) {

                commit('SET_CURSO', response.data[0]) // set the first element of array.

                return true

            } else {

                dispatch('Errors/setError', { error:'CODE02', componentId: componentId }, { root: true })

            }

        } catch (error) {

            // console.log(error.response.data.code)
            // console.log('handle errors')

            dispatch('Errors/setError', { error:'CODE01', componentId: componentId }, { root: true })

        }

    },

    /**
     * Set error in selects & disable the option not avaliable
     * 
     */

    async selectsSetsErrors({commit,state},{grupos}) {

        state.selects.forEach( (select, i)  => {

            let error = []

            grupos.forEach( grupo => {

                let index = select.groupsIds.indexOf(grupo)

                if( index != -1 ) error.push(grupo)

            })

            if( error.length > 0 ) {

                state.selects[i].error  = true

                error.forEach( e => {

                    state.selects[i].options.forEach( (o,io) => {

                        if( io > 0 ) {

                            if( o.value.group_id && o.value.group_id === e ) {
                                
                                state.selects[i].options[io].disabled = true
                                state.selects[i].options[io].text = state.selects[i].options[io].text + ' ' + i18n.t('forms.full')

                            }

                        }

                    })
                    
                })

            }

        })

    },

    async resetPremasState({state}) {

        try {

            state.prematricula = null
            state.curso = null
            state.alumnos = []
            state.alumnosid = []
            state.selects = []

            return true
            

        }  catch (error) {

            return false

        }

    }

}

const mutations = {

    /**
     * Change the logion state
     * 
     */
    
    SET_PREMATRICULA(state, data) {

        state.prematricula = data

    },

    /**
     * Alumno id 
     * 
     */

    SET_ALUMNOID(state, id) {

        state.alumnosid.push(id)

    },

    /**
     * Alumno 
     * 
     */

    SET_ALUMNO(state, a) {

        let prematricula = {idioma: a.idioma, nivel: a.nivel}

        let alumno_group = {
            id: a.alumno.id,
            name: a.alumno.nombre,
            dni: a.alumno.dni,
            prematriculas: [prematricula]
        }

        state.alumnos.push(alumno_group)

    },

    /**
     * Update alumno
     * 
     */

    UPDATE_ALUMNO(state, a) {

        let exists = state.alumnos.find(al => al.id === a.alumno.id)

        if( typeof exists !== 'undefined' ) {

            let prematricula = {idioma: a.idioma, nivel: a.nivel}
            let index = state.alumnos.indexOf(exists)

            state.alumnos[index].prematriculas.push(prematricula)

        }

    },

    /**
     * Reset alumnos
     * 
     */

    RESET_ALUMNOS(state) {

        state.alumnos = []
        state.alumnosid = []

    },

    /**
     * Select
     * 
     */

    SET_SELECT( state, select ) {

        state.selects.push( select )

    },

    /**
     * Set curso
     * 
     */

    SET_CURSO( state, data ) {

        state.curso = data

    },

    /**
     * Set locale
     * 
     */

    SET_LOCALE( state, locale ) {

        state.locale = locale

    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}